import { failure, success } from 'utils/actionTypesHelpers';

export const EXCHANGE_TOKEN = 'EXCHANGE_TOKEN';
export const EXCHANGE_TOKEN_FAILURE = failure(EXCHANGE_TOKEN);
export const EXCHANGE_TOKEN_SUCCESS = success(EXCHANGE_TOKEN);
